import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const setToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
};

setToken(localStorage.getItem('token'));

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),
    user: null,
    initialLink: '/',
    ready: false,
    groupBy: true,
  },
  getters: {
    token: state => state.token,
    ready: state => state.ready,
    groupBy: state => state.groupBy,
    user: state => state.user,
    loggedin: state => !!state.user,
    initialLink: state => state.initialLink || 'home',
    loggingin: state => {
      return state.token && !state.loginstatus
    }
  },
  mutations: {
    groupBy: (state, groupBy) => state.groupBy = groupBy,
    ready: (state) => state.ready = true,
    setReady: (state, ready) => state.ready = ready,
    setLoginPage(state, page) {
      if (page !== '/logout' && page !== '/login') {
        state.initialLink = page;
      } else {
        state.initialLink = '/';
      }
    },
    setToken: (state, token) => {
      state.token = token;

      setToken(token);
      localStorage.setItem('token', token);
    },
    login: (state, user) => {
      state.loginstatus = true;
      state.user = user;
    },
    logout: (state) => {
      state.loginstatus = false;
      state.user = null;

      setToken('');
      localStorage.removeItem('token');
    },
    finishLogin: (state) => {
      state.loginstatus = true;
    }
  },
  actions: {
    async login({ commit }) {
      try {
        let user = await Vue.axios('/api/getInfo');

        if (user.data.error) {
          return null;
        }

        commit('login', user.data);

        return user.data;
      } catch(e) {
        console.log(e);
        commit('finishLogin');
        return null
      }
    }
  }
});
